import script from "./confirmOrder.vue?vue&type=script&setup=true&lang=js"
export * from "./confirmOrder.vue?vue&type=script&setup=true&lang=js"

import "./confirmOrder.vue?vue&type=style&index=0&id=361486ce&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-361486ce"]])

export default __exports__